import { useMutation } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
import insertWisetackMutation from './insert_wisetack_payment_plan.graphql.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { TREATMENT_FLOW_PAYMENT_METHOD_FLAG } from 'Data/common-constants'

export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let [, executeMutation] = useMutation(mutation)
  let [, executeInsertWisetackMutation] = useMutation(insertWisetackMutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ value }) {
    try {
      if (value.value !== value.originalValue) {
        let variables = {
          organization_id: value.location.id, // ok to be id and not _id
          upsert_feature_flag: {
            organization_id: value.location.id, // ok to be id and not _id
            message_key: TREATMENT_FLOW_PAYMENT_METHOD_FLAG,
            message_value: value.value,
          },
        }

        let mutationResponse =
          value.value === 'wisetack'
            ? await executeInsertWisetackMutation({
                ...variables,
                payment_plan: {
                  name: 'Pay over time with Wisetack',
                  description: 'Pay in installments',
                  downpayment: 100,
                  downpayment_type: 'percentage',
                  length: 0,
                  length_type: 'total',
                  frequency: 'None',
                  order: 0,
                  organization_id: value.location._id,
                  discounts: {
                    data: [],
                  },
                },
              })
            : await executeMutation(variables)

        if (mutationResponse.error) {
          notify(notifyError('Something went wrong. Please, try again.'))
          return
        }

        notify(notifySuccess('Changes saved!'))
      }
    } catch (error) {
      notify(notifyError('Something went wrong. Please, contact support.'))
    }
  }
}
